import React, { Fragment, PureComponent, ReactNode } from 'react';
import { Toggle } from '../../components/behavior/Toggle';
import { FontIcon } from '../../components/FontIcon';
import { NavigationLink, NavigationList } from '../../components/Navigation';
import {
  NavigationListItemMobile,
  NavigationMobile,
  NavigationToggleButton
} from '../../components/NavigationMobile';
import {
  selectIsPathContentLoaded,
  selectMenu
} from '../../provider/Typo3Provider/selectors';
import { MenuEntry, Typo3State } from '../../provider/Typo3Provider/types';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';
import Locations from './Locations';

interface NavigationContainerProps {
  onClickChild: () => void;
}

const FontIconLink = FontIcon.withComponent(NavigationLink);

const renderMenuEntryChildren = (
  children: MenuEntry[],
  onClickChild: () => void
) =>
  children.map((entry, index) => (
    <NavigationListItemMobile key={index}>
      <FontIconLink
        to={entry.link}
        icon="arrow"
        arrow="right"
        onClick={onClickChild}
      >
        {entry.title}
      </FontIconLink>
    </NavigationListItemMobile>
  ));

const renderMenuEntry = (
  childrenHandler: (entries: MenuEntry[], onClickChild: () => void) => ReactNode
) => (
  { children = [], link, title, uid }: MenuEntry,
  index: number,
  onClickChild: () => void
) => {
  const toggleContent = childrenHandler(children, onClickChild);

  if (children.length) {
    return (
      <Toggle
        key={index}
        render={({ active, onClick }) => (
          <NavigationListItemMobile
            key={uid}
            // preventDefault
            onClick={onClick}
            open={active}
          >
            <NavigationLink to={link} onClick={onClickChild}>
              <span>{title}</span>
            </NavigationLink>
            <NavigationToggleButton />
            <NavigationList>{toggleContent}</NavigationList>
          </NavigationListItemMobile>
        )}
      />
    );
  }
  return (
    <NavigationListItemMobile key={uid}>
      <NavigationLink to={link} onClick={onClickChild}>
        <span>{title}</span>
      </NavigationLink>
    </NavigationListItemMobile>
  );
};

interface NavigationContentProps {
  typo3: Typo3State;
  onClickChild: () => void;
}

const NavigationContent = ({ typo3, onClickChild }: NavigationContentProps) => {
  const main = selectMenu(typo3, 'main');
  const locations = selectMenu(typo3, 'locations');
  const [, countries = null] = selectMenu(typo3, 'footer');
  const menuEntryRenderer = renderMenuEntry(renderMenuEntryChildren);
  return (
    <Fragment>
      {main.map((menuEntry, index) =>
        menuEntryRenderer(menuEntry, index, onClickChild)
      )}
      {countries && (
        <Locations
          locationEntries={locations}
          countryEntries={countries.children || []}
        />
      )}
    </Fragment>
  );
};

class NavigationContainerMobile extends PureComponent<
  NavigationContainerProps & WithTypo3Props
> {
  public render() {
    const { typo3, onClickChild } = this.props;
    const isPathContentLoaded = selectIsPathContentLoaded(typo3);
    return (
      <NavigationMobile>
        <NavigationList>
          {isPathContentLoaded && (
            <NavigationContent typo3={typo3} onClickChild={onClickChild} />
          )}
        </NavigationList>
      </NavigationMobile>
    );
  }
}

export default withTypo3(NavigationContainerMobile);
